import React from 'react'

function YoutubeIntro() {
  return (
    <div className='overflow-hidden rounded-[1.5rem] border border-slate-200 bg-slate-950 shadow-[0_18px_50px_rgba(15,23,42,0.12)]'>
      <iframe
        className='h-[230px] w-full sm:h-[280px] lg:h-[320px]'
        src='https://www.youtube.com/embed/kHRs42PGvPE?si=4AArEpceE85GQxFh'
        title='YouTube video player'
        frameBorder='0'
        allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
        referrerPolicy='strict-origin-when-cross-origin'
        allowFullScreen
      />
    </div>
  )
}

export default YoutubeIntro